export default __webpack_public_path__ + "static/media/Rhome.f9cbe3e7.svg";